import { render, staticRenderFns } from "./FieldSetField.vue?vue&type=template&id=13497126&scoped=true"
import script from "./FieldSetField.vue?vue&type=script&lang=js"
export * from "./FieldSetField.vue?vue&type=script&lang=js"
import style0 from "./FieldSetField.vue?vue&type=style&index=0&id=13497126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13497126",
  null
  
)

export default component.exports